
export const headlines = {
  default: {
    title: 'Do you have events?',
    subtext: 'Create an ECAL Free Trial account in seconds, so you can communicate events better! Enjoy 30 days FREE.',
  },

  basic: {
    title: 'Let\'s do this!',
    subtext: 'Create an ECAL Basic account in seconds, and communicate events better!',
  },

  community: {
    title: 'Let\'s do this!',
    subtext: 'Create an ECAL Community account in seconds, and communicate events better!',
  },

  grow: {
    title: 'Let\'s do this!',
    subtext: 'Create an ECAL Grow account in seconds, and communicate events better!',
  },

  pro: {
    title: 'Let\'s do this!',
    subtext: 'Create an ECAL Professional account in seconds, and communicate events better!',
  },

  enterprise: {
    title: 'Let\'s do this!',
    subtext: 'Create an ECAL Enterprise account in seconds, and communicate events better!',
  },
};

export function getHeadline (env) {
    const ptag = env?.settings?.planTag;
    if (ptag && headlines[ptag]) {
        return headlines[ptag];
    }
    return headlines.default;
}
